module.exports = __webpack_public_path__ + "azure-service-fabric.3a7b659659fdf4b0ab7eb9e202202e40.hashedasset.svg";